module.exports = "/assets/data/af2e90c83d9e40fe8ed5b54bb63fe22d-BN18.data.json";